// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { IDefinitionChangeParam, useAddRole, useUpdateConfirmationParameter, useGetUserTypeList, useAddConfirmationParameter, useAddDefinitionChangeParam, useUpdateDefinitionChangeParam } from "../../../hooks";
import { Autocomplete, Box, FormControl, Stack, TextField, useMediaQuery, useTheme } from "@mui/material";
import { BaseModal, BaseModalProps, InputControl } from "../../molecules";
import { Button, Loading } from "../../atoms";
import { useForm, Controller } from "react-hook-form";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  confirmationAddFormSchema,
  ConfirmationAddFormSchemaFormValuesType,
  confirmationAddInitialValues,
} from "./_formTypes";
import { useEffect, useMemo } from "react";


export type ConfirmationAddModalProps = BaseModalProps & {
  title?: string;
  parameter?: IDefinitionChangeParam;
};

export const ConfirmationAddModal = ({
  onClose,
  parameter,
  isOpen,
  title = "Parametre Ekle",
}: ConfirmationAddModalProps) => {
  const { control, reset, handleSubmit } =
    useForm<ConfirmationAddFormSchemaFormValuesType>({
      resolver: zodResolver(confirmationAddFormSchema),
      defaultValues: confirmationAddInitialValues,
    });
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const { mutate: addDefinitionChangeParam, isLoading } = useAddDefinitionChangeParam();
  const { mutate: updateDefinitionChangeParam, isLoading: isUpdateLoading } = useUpdateDefinitionChangeParam();


  const setSnackbar = useSetSnackBar();




  const onSubmit = (data: any) => {
    if (data?.processGroup) {
      data.processGroup = data.processGroup.toUpperCase();
    }

    if (data?.processType) {
      data.processType = data.processType.toUpperCase();
    }

    if (parameter && parameter?.id > 0) {
      updateDefinitionChangeParam(
        { ...data, id: parameter.id },
        {
          onSuccess(data) {
            if (data.isSuccess) {
              onClose();
              setSnackbar({
                severity: "success",
                isOpen: true,
                description: data.message,
              });
            } else {
              setSnackbar({
                severity: "error",
                isOpen: true,
                description: data.message,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: "İşlem sırasında bir hata oluştu",
            });
          },
        }
      );
    } else {
      addDefinitionChangeParam(data, {
        onSuccess(data) {
          if (data.isSuccess) {
            onClose();
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: data.message,
            });
          } else {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: data.message,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "İşlem sırasında bir hata oluştu",
          });
        },
      });
    }
  };



  useEffect(() => {
    if (!!parameter && JSON.stringify(parameter) !== "{}") {
      reset({
        processGroup: `${parameter.processGroup}`,
        processType: `${parameter.processType}`,
        roleLevel: `${parameter.roleLevel}`,
        process: `${parameter.process}`
      });
    }
  }, [reset, parameter]);

  useEffect(() => {
    if (isOpen === false) {
      reset({});
    }
  }, [isOpen]);

  return (
    <>
      {(isLoading || isUpdateLoading) && <Loading />}
      <BaseModal onClose={onClose} title={title} isOpen={isOpen}>
        <Stack flex={1} p={4}>
          {/* !!! --- FORM --- !!! */}
          <Stack spacing={2} flex={1}>
            <Stack alignItems="center" direction={isDesktop ? "row" : "column"} spacing={2}>

              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                <InputControl
                  size="medium"
                  sx={{ flex: 1, width: "100%" }}
                  id="processGroup"
                  label="İşlem Grubu"
                  control={control}
                />
              </FormControl>

              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                <InputControl
                  size="medium"
                  sx={{ flex: 1, width: "100%" }}
                  id="processType"
                  label="İşlem Tipi"
                  control={control}
                />
              </FormControl>
            </Stack>
            <Stack alignItems="center" direction={isDesktop ? "row" : "column"} spacing={2}>

              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                <InputControl
                  size="medium"
                  type="number"
                  sx={{ flex: 1, width: "100%" }}
                  id="roleLevel"
                  label="Rol Seviyesi"
                  control={control}
                />
              </FormControl>
              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
              </FormControl>
            </Stack>

          </Stack>
          {/* !!! --- Button --- !!! */}
          <Stack justifyContent="flex-end" alignItems="center" direction="row">
            <Button
              variant="contained"
              text={parameter ? "Güncelle" : "Ekle"}
              onClick={handleSubmit(onSubmit)}
            />
          </Stack>
        </Stack>
      </BaseModal>
    </>
  );
};
